/* global axios */
import ApiClient from './ApiClient';

class ArticleReportsAPI extends ApiClient {
  constructor() {
    super('article_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getArticleReports(queryParams) {
    return axios.get(`${this.url}?${queryParams}`);
  }

  getSummary(queryParams) {
    return axios.get(`${this.url}/summary?${queryParams}`);
  }

  getTimeline(queryParams) {
    return axios.get(`${this.url}/timeline?${queryParams}`);
  }
}

export default new ArticleReportsAPI();
